/* eslint-disable @typescript-eslint/naming-convention */
export enum BatteryType {
  ION_PI966 = 'ION_PI966',
  ION_PI967 = 'ION_PI967',
  METAL_PI969 = 'ION_PI969',
  METAL_PI970 = 'ION_PI970',
}
